import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class TabView extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'tab_panel+',
      group: 'block',
      isolating: true,
      parseDOM: [],
      toDOM: () => ['div', { class: 'tabsContainer border border-border-red p-24' }, ['span', 0]],
    };
  }

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }
}
